import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

interface ProductGroupProps extends AutoCompleteProps {
  itemCategoryCode?: string | null;
}

const ProductGroupAutoComplete: React.FC<ProductGroupProps> = ({
  onChange,
  valueId,
  label,
  load = true,
  disabled = false,
  infoText,
  error,
  helperText,
  itemCategoryCode,
}) => {
  const { t } = useTranslation();
  const url = `/autocompleteApi/ProductGroup?itemCategoryCode=${itemCategoryCode ?? ""}&`;

  return (
    <AsyncAutoCompleteContained
      key={itemCategoryCode ?? "none"}
      label={label ?? t("common.productGroup")}
      url={url}
      valueId={valueId}
      load={load && !!itemCategoryCode}
      onChange={onChange}
      disabled={disabled || !itemCategoryCode}
      infoText={infoText}
      error={error}
      helperText={helperText}
    />
  );
};

export default ProductGroupAutoComplete;
